export const isValidString = (valueParam) => (typeof valueParam === 'string' && valueParam.length > 0);
export const isValidStringOrNull = (strParam) => (isValidString(strParam) || strParam === null);
export const isValidAbsolute = (valueParam) => (typeof valueParam === 'number' && !Number.isNaN(valueParam));
export const validIntGtZero = (numParam) => (isValidAbsolute(numParam) && numParam > 0);
export const validIntGtEqZero = (numParam) => (isValidAbsolute(numParam) && numParam >= 0);
export const isValidDate = (dateParam) => {
  const getMonth = dateParam?.getMonth ?? null;
  return (typeof getMonth === 'function' && Object.prototype.toString.call(dateParam) === '[object Date]');
};
export const isValidArray = (arrayParam) => (Array.isArray(arrayParam) && arrayParam.length > 0);
export const isEmptyArray = (arrayParam) => (Array.isArray(arrayParam) && arrayParam.length === 0);
